import { TLiftedFormModel } from './form.model';
import { TASK_FORM } from './form.tasks';

const log = <T>(formModel: TLiftedFormModel<T>): TLiftedFormModel<T> => {
  //console.log('[LOG] Form Model', formModel);
  return formModel;
};

export const PIPELINE_FORM = {
  /**
   * Performs creatUids and moveHiddenToLast tasks on the form-model.
   * @param formModel
   * @returns formModel
   */
  sanitize: <T>(formModel: TLiftedFormModel<T>): TLiftedFormModel<T> => {
    return [TASK_FORM.creatUids, TASK_FORM.moveHiddenToLast, TASK_FORM.isValid, log].reduce((a, v) => v(a), formModel);
  },
  /**
   *
   * Performs validation on the model (currently checks for isRequired field and performs validation on that)
   * update the dependent Fields and generates the payload.
   * @param formModel
   * @returns formModel
   */
  runPipelineOnInputUpdate: <T>(formModel: TLiftedFormModel<T>): TLiftedFormModel<T> => {
    return [TASK_FORM.isValid, TASK_FORM.updateDependentFields, TASK_FORM.generatePayload, log].reduce(
      (a, v) => v(a),
      formModel,
    );
  },

  generatePayload: <T>(formModel: TLiftedFormModel<T>): TLiftedFormModel<T> => {
    return [TASK_FORM.generatePayload, log].reduce((a, v) => v(a), formModel);
  },

  setValues: <T>(formModel: TLiftedFormModel<T>): TLiftedFormModel<T> => {
    return [
      TASK_FORM.setOptions,
      TASK_FORM.setValues,
      TASK_FORM.setChecked,
      TASK_FORM.isValid,
      TASK_FORM.updateDependentFields,
      TASK_FORM.generatePayload,
      log,
    ].reduce((a, v) => v(a), formModel);
  },
};
